// Control names for the player, through the strings table: `control.<name>` for named keys, mouse buttons and pad
// buttons; letters and digits show as themselves (the raw-string scan lets a single key glyph through); anything
// else is "Other key". Control names are the runtime's (`KeyW`, `Mouse0`, `Pad0`, `PadLeft`, `Touch:move`).
import type { Translate } from "@rpg/ui";

/** The player's name for a control. `has` says whether the strings table has an id. */
export function controlLabel(t: Translate, has: (id: string) => boolean, control: string): string {
  const letter = /^Key([A-Z])$/.exec(control) ?? /^Digit([0-9])$/.exec(control);
  if (letter) return letter[1]!;
  if (control.startsWith("Touch:")) return t(control.includes("stick") || control.endsWith(":move") ? "control.touch.stick" : control.includes("drag") || control.endsWith(":look") ? "control.touch.drag" : "control.touch.button");
  const id = `control.${control}`;
  return has(id) ? t(id) : t("control.other");
}
